import { useContext, useEffect, useState } from "react";
import AuthContext from "../../components/auth-context";
import PurchaseTicketApi from "../../api/purchase-ticket";
import { useParams } from "react-router-dom";

function Result() {
  const context = useContext(AuthContext);
  const [discountCode, setDiscountCode] = useState("");
  const [serviceTitle, setServiceTitle] = useState<string | null>(null);

  let { receiptId } = useParams();

  useEffect(() => {
    const Api = new PurchaseTicketApi(context);
    Api.get(receiptId).then((result) => {
      // console.log(result);
      setDiscountCode(result.value);
      setServiceTitle(result.serviceTitle);
    });
    // eslint-disable-next-line
  }, [receiptId]);
  return (
    <>
      <div
        className="card dcard"
        style={{ padding: "5px", marginBottom: "20px" }}
      >
        <h1>کدتخفیف فیلیمو</h1>
        <table
          id="simple-table "
          className="table table-condensed table-striped table-bordered"
        >
          <thead>
            <tr>
              <th>عنوان</th>
              <th>کدتخفیف</th>
            </tr>
          </thead>
          <tbody className="mt-1">
            <tr className="bgc-h-yellow-l4 d-style">
              <td className="text-right pr-25 pos-rel payment-title-td">
                {serviceTitle}
              </td>
              <td className="text-right pr-25 pos-rel">
                <button
                  title="کپی"
                  className="discount"
                  onClick={() => navigator.clipboard.writeText(discountCode)}
                >
                  {discountCode}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}
export default Result;
